import { BuildingLibraryIcon, BuildingOffice2Icon, ChartBarIcon, Cog6ToothIcon, EyeIcon, ListBulletIcon, MapIcon, ServerStackIcon, UserGroupIcon } from '@heroicons/react/24/outline'
import { BookPlusIcon, Brain, BrainCog, FolderCog, SquareChevronRight } from 'lucide-react'
import { Outlet } from 'react-router-dom'

import ErrorBoundary from '@/components/ErrorBoundary'
import Layout, { INavLink } from '@/components/Layout'

import logo from '../../logo-white-no-bg.svg'

const ADMIN_LINKS: INavLink[] = [
    { text: 'Analytics', href: '/admin', icon: ChartBarIcon },
    { text: 'Users', href: '/admin/users', icon: UserGroupIcon },
    { text: 'Resources', href: '/admin/resources', icon: BookPlusIcon },
    { text: 'AI Knowledge Base', href: '/admin/knowledge-base', icon: Brain },
    { text: 'Chat Prompt Settings', href: '/admin/chat-prompt-settings', icon: SquareChevronRight },
    { text: 'Roadmap Milestones', href: '/admin/roadmap-milestones', icon: MapIcon },
    { text: 'Roadmap Sequences', href: '/admin/roadmap-sequences', icon: ListBulletIcon },
    { text: 'Organizations', href: '/admin/organizations', icon: BuildingLibraryIcon },
    { text: 'App Settings', href: '/admin/app-settings', icon: Cog6ToothIcon },
    { text: 'System', href: '/admin/system', icon: ServerStackIcon },
    { text: 'Family Care Team (Preview)', href: '/admin/family-care-team-preview/team', icon: EyeIcon },
    { text: 'Provider Portal (Preview)', href: '/admin/provider-preview/dashboard', icon: EyeIcon },
    { text: 'Find-a-Provider Search', href: '/admin/providers', icon: BuildingOffice2Icon },
    { text: 'Find-a-Provider: Types', href: '/admin/provider-categories', icon: FolderCog },
]

const FOOTER_LINKS = [
    { text: 'Site Home', href: '/' },
    { text: 'Logout', href: '/logout' },
]

export default function AdminLayout() {
    return (
        <Layout
            variant='admin'
            logo={logo}
            primaryLinks={[...ADMIN_LINKS]}
            secondaryLinks={[]}
            footerLinks={FOOTER_LINKS}
        >
            <ErrorBoundary componentName='App'>
                <Outlet></Outlet>
            </ErrorBoundary>
        </Layout>
    )
}
